import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Umbrella03 = function Umbrella03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6.25 21.9595 12 12.0002M17 3.34C12.6868.8497 7.2896 1.9378 4.246 5.683c-.297.3656-.4456.5484-.4888.8103-.0344.2083.0165.4844.123.6668.1338.2293.371.3662.8452.64l14.5492 8.4c.4743.2738.7114.4107.9768.412.2112.001.4758-.093.6391-.2269.2052-.1684.2892-.3884.4572-.8285C23.0695 11.0483 21.3132 5.8302 17 3.3399m0 0c-1.9132-1.1046-5.7027 1.8773-8.4641 6.6602M17 3.34c1.9132 1.1045 1.2255 5.8773-1.5359 10.6602m6.5359 8H2"
    })
  }));
};
export default Umbrella03;